import React, { useContext } from 'react';
import RelatorioTurmaTable from './RelatorioTurmaTable';
import withRouter from 'react-router-dom/withRouter';
import { Button } from '@material-ui/core';
import { get } from 'lodash';
import ExcelExporter from '../utils/excel';
import { FilterRelatorioContext } from '../contexts/FilterRelatorioProvider/Context';

const RelatorioTurmaColumn = ({
  hideHeader,
  relatorios,
  history,
  periodo,
  tituloCompleto,
  prova,
  ano,
  disciplina,
  ...rest
}) => {
  const { setStateFilters, filtrosRelatorios } = useContext(FilterRelatorioContext);
  const columns = [
    {
      Header: 'Estudante',
      headerStyle: {
        'border-top-left-radius': '10px',
        display: 'flex',
        'justify-content': 'center'
      },
      Cell: (row) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer'
          }}
        >
          <div
            onClick={() => {
              setStateFilters({ selectedAluno: row.original.idn });
              window.open(`/filter-aluno?idn=${row.original.idn}&periodoAno=${periodo}`);
            }}
          >
            {row.original.NM_ALUNO}
          </div>
        </div>
      ),
      accessor: 'NM_ALUNO',
      sortable: false,
      className: 'd-flex justify-content-start align-items-center'
    },
    {
      Header: 'Proficiência',
      headerStyle: {
        display: 'flex',
        'justify-content': 'center'
      },
      accessor: 'NT_ALUNO',
      sortable: false,
      className: 'd-flex justify-content-center align-items-center',
      width: 200
    },
    {
      Header: 'Nível de Proficiência',
      headerStyle: {
        'border-top-right-radius': '10px',
        display: 'flex',
        'justify-content': 'center'
      },
      width: 300,

      Cell: (row) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <div>{row.original.proficiencia_aluno}</div>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              backgroundColor: row.original.cor,
              width: '25px',
              height: '10px',
              borderRadius: '10px'
            }}
          />
        </div>
      ),
      sortable: false
    }
  ]

  const dadosCSV =
    relatorios &&
    relatorios.map((dado) => {
      return {
        Estudante: get(dado, 'NM_ALUNO'),
        'Proficiência': get(dado, 'NT_ALUNO'),
        'Nível de Proficiência': get(dado, 'proficiencia_aluno'),
        Prova: get(prova, '[0].ds_periodo'),
        Disciplina: disciplina,
        Escola: get(dado, 'NM_ESCOLA'),
        Etapa: get(dado, 'NM_ETAPA'),
        Turma: get(dado, 'NM_TURMA')
      };
    });

  const handleExportExcel = () => {
    const excelExporter = new ExcelExporter();
    excelExporter.export(dadosCSV, tituloCompleto, []);
  };

  return (
    <div className="mb-1" style={{ width: '100%' }}>
      <RelatorioTurmaTable columns={columns} data={relatorios} {...rest} />
      {tituloCompleto && relatorios && (
        <div style={{ marginTop: '1rem', textAlign: 'center' }}>
          <Button onClick={() => handleExportExcel()}>
            Baixar dados da tabela
          </Button>
        </div>
      )}
    </div>
  );
};

export default withRouter(RelatorioTurmaColumn);
